export enum AssetAdminTab {
  HOME = 'home',
  PAGES = 'pages',
  NEWS = 'news',
  COURSE = 'course',
}

export const tabToLabel = {
  [AssetAdminTab.NEWS]: 'Nyheter',
  [AssetAdminTab.COURSE]: 'Kurs',
  [AssetAdminTab.PAGES]: 'Sider',
  [AssetAdminTab.HOME]: '..',
};
